import React, { FC, useState } from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { Beneficiary } from '~/types';
import { cleanupFormValues } from '~/utils';
import BeneficiaryForm from './BeneficiaryForm';
import { beneficiaries } from '~/routes';
import { FormDrawer } from '~/components';
import { usePermissions } from '~/hooks';
import { useBeneficiariesCreate } from '~/hooks/beneficiaries';

const BeneficiaryCreate: FC<any> = () => {
  const [t] = useTranslation('payouts');

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const { mutate } = useBeneficiariesCreate({ onMutate: handleClose });

  const onFinish = (values: Beneficiary) => {
    mutate(cleanupFormValues(values));
  };

  const hasAccess = usePermissions('business.beneficiary.create');
  if (!hasAccess) return null;
  return (
    <>
      <Button onClick={handleOpen} type="primary">
        {t('addBeneficiary')}
      </Button>
      <FormDrawer
        name={beneficiaries}
        onFinish={onFinish}
        title={t('addBeneficiary')}
        onClose={handleClose}
        visible={open}
      >
        <BeneficiaryForm name={beneficiaries} />
      </FormDrawer>
    </>
  );
};

export default BeneficiaryCreate;
